import { css } from '@emotion/react';
import { classNames } from '@frontend/string';
import { theme } from '@frontend/theme';

export type StatusDotProps = {
  size?: number;
  color?: string;
  className?: string;
};

const styles = ({ size, color }: { size: number; color: string }) => {
  return css({
    width: size,
    height: size,
    borderRadius: '50%',
    backgroundColor: color,
  });
};

const StatusDot: StatusDotNamespace = ({ size = 8, color = theme.colors.neutral50, className }) => {
  return <div className={classNames('status-dot', className)} css={styles({ size, color })}></div>;
};

const SuccessStatusDot = ({ size = 8, color = theme.colors.success50, className }: StatusDotProps) => {
  return <StatusDot size={size} color={color} className={className} />;
};

const NeutralStatusDot = ({ size = 8, color = theme.colors.neutral20, className }: StatusDotProps) => {
  return <StatusDot size={size} color={color} className={className} />;
};

interface StatusDotNamespace extends React.FC<React.PropsWithChildren<StatusDotProps>> {
  Success: typeof SuccessStatusDot;
  Neutral: typeof NeutralStatusDot;
}

StatusDot.Success = SuccessStatusDot;
StatusDot.Neutral = NeutralStatusDot;

export { StatusDot };
